import './css/NavBar.css'
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {FormattedMessage} from "react-intl";

export default function NavBar(props) {
    const [hoverLang, setHoverLang] = useState(false);
    const [hoverPage, setHoverPage] = useState(false);
    const navigate = useNavigate();
    const langs = ["Ua", "En"]
    const pages = ["Api", "Fields", "Dictionary", "Objects"]

    const redirectUrl = {
        "Api": '/api',
        "Fields": '/fields',
        "Dictionary": '/dictionary',
        "Objects": '/object'
    }

    const indexLang = langs.indexOf(props.lang);
    if (indexLang !== -1) {
        langs.splice(indexLang, 1);
    }
    const indexPage = pages.indexOf(props.page);
    if (indexPage !== -1) {
        pages.splice(indexPage, 1);
    }
    return (
        <header className="header--sticky">
            <div className="header-container">
                <div className="inner-container">
                    <div className="brand">
                        <a className="logo logo--md" style={{width: "173px"}}>
                            <div className="header-logo">
                                <img className="clever" src="https://dev.cleverstaff.net/external/images/clever.gif"
                                     alt="CleverStaff"/>
                                <img className="logo-text"
                                     src="https://dev.cleverstaff.net/external/images/logo-text.gif"
                                     alt="CleverStaff"/>
                            </div>
                        </a>
                    </div>
                    <div className="control">
                        <div className="dropdown-container" style={{width: "100px"}}
                             onMouseOver={() => setHoverPage(true)}
                             onMouseLeave={() => setHoverPage(false)}>
                            <div style={{color: hoverPage ? "black" : "#348034"}}><FormattedMessage id={props.page}/><i
                                className="arrow down" style={{borderColor: hoverPage ? "black" : "#348034"}}></i></div>
                            {hoverPage &&
                                <div className="dropdown-options" style={{width: "100px"}}>
                                    {pages.map((p, i) => (
                                        <div key={i} className="dropdown-option" onClick={() => {
                                            navigate(redirectUrl[p])
                                            setHoverPage(false)
                                        }}>
                                            <hr/>
                                            <FormattedMessage id={p}/></div>
                                    ))}
                                </div>}
                        </div>
                        <div className="dropdown-container" onMouseOver={() => setHoverLang(true)}
                             onMouseLeave={() => setHoverLang(false)}>
                            <div style={{color: hoverLang ? "black" : "#348034"}}>{props.lang}<i className="arrow down"
                                                                                                 style={{borderColor: hoverLang ? "black" : "#348034"}}></i>
                            </div>
                            {hoverLang &&
                                <div className="dropdown-options">
                                    {langs.map((l, i) => (
                                        <div key={i} className="dropdown-option" onClick={() => {
                                            props.setLang(l)
                                            localStorage.setItem("lang", l)
                                            setHoverLang(false)
                                        }}>{l}</div>
                                    ))}
                                </div>}
                        </div>
                        {window.screen.width > 425 &&
                            <a className="go-cs" href="https://cleverstaff.net/"><FormattedMessage
                                id='Go to CleverStaff'/>
                            </a>}
                    </div>
                </div>
            </div>
        </header>
    )
}